module.exports = __webpack_public_path__ + "static/rph2rph-tab-5dfdb9eb7323ecf7e655b9a2a3d389a3.png";